import { useState, useEffect } from "react";
import logoSrc from "@/assets/logo-new.png?format=webp";

interface AnimatedLogoProps {
  className?: string;
}

const AnimatedLogo = ({ className = "h-14 w-auto" }: AnimatedLogoProps) => {
  const [showOverlay, setShowOverlay] = useState(false);

  return (
    <div className={`relative inline-flex items-center ${className}`} style={{ isolation: "isolate" }}>
      <img
        src={logoSrc}
        alt="Sullivan Care"
        width={288}
        height={192}
        className="h-full w-auto object-contain block"
        fetchPriority="high"
        onLoad={() => setShowOverlay(true)}
      />
      {showOverlay && (
        <div
          className="absolute inset-0 logo-gradient-overlay"
          style={{
            mixBlendMode: "color",
            WebkitMaskImage: `url(${logoSrc})`,
            maskImage: `url(${logoSrc})`,
            WebkitMaskSize: "contain",
            maskSize: "contain",
            WebkitMaskRepeat: "no-repeat",
            maskRepeat: "no-repeat",
            WebkitMaskPosition: "center",
            maskPosition: "center",
          }}
        />
      )}
    </div>
  );
};

export default AnimatedLogo;
